//CEC.js - CaptureExec CONSTANTS
import * as JSFUNC from '../Library/JSFUNC.js';
//----------------------------------------------------------------------------------
//Code Version
export const userBrowserCodeVesions = {
  DEV_CODE_VERSION: "2026.Q4.3.1", //[year].Q[quarter release 1,2,3,4].[live push increment].[dev push increment]
  LIVE_CODE_VERSION: "2026.Q4.3" //[year].Q[quarter release 1,2,3,4].[live push increment]
};

//----------------------------------------------------------------------------------
//On-Premise Customer Flags

export const onPremiseCustomer = {
  ON_PREMISE_CUSTOMER_TF: false,
  CHECK_AUTHENTICATION_QUARTERLY_PASSCODE_FILE_TF: false,
  BIT_COMPANY_DOMAINS_DOT_EXTS_ARRAY: ["bitsolutionsllc.com"],
  BIT_PRODUCT: undefined, //this value is not needed for cloud customers (product is determined by website address url)
  BIT_NUM_LICENSES_PURCHASED: 999,
  BIT_LICENSE_START_DATE: "2012-07-12",
  BIT_LICENSE_NUM_MONTHS: 999,
  BIT_SUPERADMINS_MAX_NUM: -1,
  BIT_SUPERADMINS_LICENSE_COST: 2,
  BIT_CONSULTANTS_LICENSE_COST: 0,
  BIT_READ_ONLY_LICENSE_COST: 0.5,
  BIT_GOVCONSMARTSEARCH_TF: false,
  BIT_CEXAI_TF: false,
  BIT_IDIQ_RAPID_RESPONSE_TF: true,
  BIT_SINGLE_CAPTURE_DIRECT_ACCESS_LINKS_TF: false,
  BIT_INTEGRATION_SYSTEM_VANTAGEPOINT_TF: false,
  BIT_SGT_DOCUMENTS_CARD_UPGRADE_01_TF: false,
  BIT_SGT_STRIPE_CUSTOMER_ID: undefined //on prem customers can't have SGT
};

/*
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//On Premise Customers (edit CEC.js, general_functions.php, CETeammateSurveyMobx.js)
export const onPremiseCustomer = {
  ON_PREMISE_CUSTOMER_TF: true,
  CHECK_AUTHENTICATION_QUARTERLY_PASSCODE_FILE_TF: true,
  BIT_COMPANY_DOMAINS_DOT_EXTS_ARRAY: ["amewas.com"],
  BIT_PRODUCT: "captureexec", //"captureexec", "samgovtracker"
  BIT_NUM_LICENSES_PURCHASED: 10,
  BIT_LICENSE_START_DATE: "2024-07-01",
  BIT_LICENSE_NUM_MONTHS: 36,
  BIT_SUPERADMINS_MAX_NUM: -1,
  BIT_SUPERADMINS_LICENSE_COST: 2,
  BIT_CONSULTANTS_LICENSE_COST: 1,
  BIT_READ_ONLY_LICENSE_COST: 0.5,
  BIT_GOVCONSMARTSEARCH_TF: true,
  BIT_CEXAI_TF: true,
  BIT_IDIQ_RAPID_RESPONSE_TF: true,
  BIT_SINGLE_CAPTURE_DIRECT_ACCESS_LINKS_TF: true,
  BIT_INTEGRATION_SYSTEM_VANTAGEPOINT_TF: false,
  BIT_SGT_DOCUMENTS_CARD_UPGRADE_01_TF: false,
  BIT_SGT_STRIPE_CUSTOMER_ID: undefined
};
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
*/



//----------------------------------------------------------------------------------
//GCSS Tab
export const gcssDataSourceIntSam0 = 0;
export const gcssDataSourceIntGovWin1 = 1;
export const gcssDataSourceIntFedComp2 = 2;
export const gcssDataSourceIntCexai3 = 3;
export const gcssDataSourceIntGovInfoRss1001 = 1001;


//----------------------------------------------------------------------------------
//Captures Tab
export const captureSummaryTableOrChartMaxNumCapturesPerStageToDraw = 50; //50


//----------------------------------------------------------------------------------
//Admin Changelog
const adminLogCategoryDescriptionDeleteCaptures = "Deleted Captures"; //100-199
const adminLogCategoryDescriptionArchiveCaptures = "Archived Captures"; //200-299
const adminLogCategoryDescriptionImportUpdateCapturesFromCsv = "Import/Update Captures from .csv"; //300-399
const adminLogCategoryDescriptionImportContactsFromCsv = "Import Contacts from .csv"; //400-499
const adminLogCategoryDescriptionMassEditCaptures = "Mass Edit Captures"; //500-599
const adminLogCategoryDescriptionCompanyDivisions = "Company/Divisions"; //1000-1099
const adminLogCategoryDescriptionUsers = "Users"; //1100-1199
const expandedActionCodesArrayOfObjs = [
  {actionCode:100,  constVarName:"DELETE_CAPTURE",                        categoryDescription:adminLogCategoryDescriptionDeleteCaptures,              actionDescription:"Admin Deleted Capture"},
  {actionCode:101,  constVarName:"DELETE_MULTIPLE_CAPTURES",              categoryDescription:adminLogCategoryDescriptionDeleteCaptures,              actionDescription:"Admin Deleted Multiple Captures from Capture Table"},
  {actionCode:200,  constVarName:"AUTOMATED_CAPTURE_ARCHIVE",             categoryDescription:adminLogCategoryDescriptionArchiveCaptures,             actionDescription:"Capture(s) Archived from Automated Rules"},
  {actionCode:201,  constVarName:"MANUAL_CAPTURE_ARCHIVE",                categoryDescription:adminLogCategoryDescriptionArchiveCaptures,             actionDescription:"User Manually Archived Capture"},
  {actionCode:300,  constVarName:"IMPORT_CAPTURES_FROM_CSV",              categoryDescription:adminLogCategoryDescriptionImportUpdateCapturesFromCsv, actionDescription:"Admin Imported Captures from .csv"},
  {actionCode:301,  constVarName:"UPDATE_CAPTURES_FROM_CSV",              categoryDescription:adminLogCategoryDescriptionImportUpdateCapturesFromCsv, actionDescription:"Admin Updated Captures from .csv"},
  {actionCode:400,  constVarName:"IMPORT_CONTACT_COMPANIES_FROM_CSV",     categoryDescription:adminLogCategoryDescriptionImportContactsFromCsv,       actionDescription:"Admin Imported Contact Companies from .csv"},
  {actionCode:401,  constVarName:"IMPORT_CONTACT_PERSONS_FROM_CSV",       categoryDescription:adminLogCategoryDescriptionImportContactsFromCsv,       actionDescription:"Admin Imported Contact Persons from .csv"},
  {actionCode:500,  constVarName:"MASS_EDIT_FIELD_FOR_MULTIPLE_CAPTURES", categoryDescription:adminLogCategoryDescriptionMassEditCaptures,            actionDescription:"Admin Mass Edited a Field across multiple Captures"},
  {actionCode:1000, constVarName:"CREATE_NEW_DIVISION",                   categoryDescription:adminLogCategoryDescriptionCompanyDivisions,            actionDescription:"Admin Created New Division"},
  {actionCode:1001, constVarName:"DELETE_DIVISION",                       categoryDescription:adminLogCategoryDescriptionCompanyDivisions,            actionDescription:"Admin Deleted Division"},
  {actionCode:1100, constVarName:"CREATE_NEW_USER",                       categoryDescription:adminLogCategoryDescriptionUsers,                       actionDescription:"Admin Created New User"},
  {actionCode:1101, constVarName:"DELETE_USER",                           categoryDescription:adminLogCategoryDescriptionUsers,                       actionDescription:"Admin Deleted User"},
  {actionCode:1102, constVarName:"EDIT_USER",                             categoryDescription:adminLogCategoryDescriptionUsers,                       actionDescription:"Admin Edit User"}
];
export const adminLogObj = {
  actionCodesObj: JSFUNC.create_new_obj_from_arrayOfObjs_field1_name_and_field2_name(expandedActionCodesArrayOfObjs, "constVarName", "actionCode"), //CEC.adminLogObj.actionCodesObj.DELETE_CAPTURE = 100
  expandedActionCodesArrayOfObjs: expandedActionCodesArrayOfObjs, //this is used in building a select that can mask the names of action codes rom the database
  invalidCategoryDescription: "--No Action Category--"
};
